export const prefixZeroFormat = (n) => {
  return n > 9 ? '' + n : '0' + n;
};
